import {
  // needAdmin,
  // needRole,
  needLogin,
  needMpAuth,
} from '../utils/error-handler';
import roleErrorMap from '../config/errcode/role';

const interceptors = {};

const query = {
  login: [],
  role: [],
};

interceptors.noLogin = (data) => {
  // 异常队列已有同类操作，则中断，由第一个进行处理
  if (query.login.length > 0) {
    return Promise.reject(new Error('=====> interceptors.noLogin queue' +
      ' processing'));
  }
  // 第一个19000请求将进行异常处理
  query.login.push(data);
  // 需求管理员权限的操作
  needLogin({
    callback () {
      query.login = [];
    },
  });
  return Promise.reject(new Error('=====> interceptors.noLogin'));
};

interceptors.roleCheck = (data) => {
  if (roleErrorMap[data.errcode]) {
    if (query.role.length > 0) {
      return Promise.reject(new Error('=====> interceptors.roleCheck queue' +
        ' processing'));
    }
    query.role.push(data);
    // todo: 和前端的用户类型校验的弹窗冲突了，故先隐藏该逻辑
    // needRole({
    //   errcode: data.errcode,
    //   errmsg: roleErrorMap[data.errcode] || data.errmsg,
    //   callback () {
    //     query.role = [];
    //   },
    // });

    return Promise.reject(new Error(roleErrorMap[data.errcode]));
  }
  return true;
};

interceptors.noMpAuth = (data, appid) => {
  if (data && data.errcode === 41001) {
    needMpAuth(appid);
    return Promise.reject(data);
  }
  return true;
};

export default interceptors;
